import * as React from "react";
import { getActions } from "./actions.js";
import { getInitialState } from "./get-initial-state.js";
import { reducer } from "./reducer.js";
import { selectors } from "./selectors.js";
import { useSolutionsProductData } from "../../../../../../../../context/context/product-context-hooks.js";
import { useDeliveryIntervalOptions } from "../../../../../../components/DeliveryIntervalSelect/modules/EcommContent/components/DeliveryIntervalSelect/use-delivery-interval-options.js";
const DEFAULT_SOLUTION_MAX_QUANTITY = 5;
const SolutionsEcommContext = React.createContext({});
const useSolutionsEcommContext = () => React.useContext(SolutionsEcommContext);
const SolutionsEcommProvider = ({
  children,
  maxOrderableQuantity
}) => {
  const { activeVariant, selectedPurchaseType } = useSolutionsProductData();
  const { availableSubscriptionIntervals } = activeVariant;
  const { singleDeliveryIntervalOption } = useDeliveryIntervalOptions({
    deliveryInterval: null,
    availableSubscriptionIntervals
  });
  const getInitialStateProps = {
    purchaseType: selectedPurchaseType,
    defaultDeliveryInterval: singleDeliveryIntervalOption?.value
  };
  const [state, dispatch] = React.useReducer(reducer, getInitialStateProps, getInitialState);
  const actions = React.useMemo(() => getActions(dispatch), []);
  React.useEffect(() => {
    actions.updatePurchaseType(selectedPurchaseType);
  }, [actions, selectedPurchaseType]);
  const value = React.useMemo(
    () => ({
      actions,
      state,
      selectors,
      maxOrderableQuantity: maxOrderableQuantity ?? DEFAULT_SOLUTION_MAX_QUANTITY
    }),
    [actions, maxOrderableQuantity, state]
  );
  return /* @__PURE__ */ React.createElement(SolutionsEcommContext.Provider, { value }, children);
};
export {
  SolutionsEcommContext,
  SolutionsEcommProvider,
  useSolutionsEcommContext
};
//# sourceMappingURL=SolutionsEcommContext.js.map
